/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useContext, useEffect, useRef, useMemo } from 'react'

import Brands from './brands/index'
import Campaigns from './campaigns'
import { ScreenSizeContext } from 'providers'
import { getValue } from 'remote-config-value'
import NumberAssignement from './number-assignement'
import { makeStyles } from '@material-ui/core/styles'
import { Loader, Tabs } from 'foundations-library/components'
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom'

import Header from './shared/Header'
import useWidget from '../hooks/useWidget'
import BrandsContext from '../contexts/BrandsContext'
import { CampaignContext } from '../contexts/CampaignContext'
import SmsEnrollmentInstruction from './SmsEnrollmentInstruction'
import { SmsNumberCampaignContext } from '../contexts/SmsNumberCampaignContext'

const styles = makeStyles((theme: any) => {
    const { colors } = theme['foundations-library'] || {}
    return {
        container: {
            maxWidth: 1000,
            margin: '0 auto'
        },
        smsEnrollmentInstructionContainer: { paddingTop: '1rem', height: '100%' },
        root: {
            width: '660px',
            margin: '0 auto',
            '& .tabs': {
                backgroundColor: colors.neutral[50],
                '& .tab': {
                    backgroundColor: 'transparent',
                    color: colors.neutral[700],
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    '&.active--tab': {
                        backgroundColor: `${colors.neutral[900]}!important`,
                        color: '#fff'
                    }
                }
            }
        },
        content: {
            marginTop: 40
        }
    }
})

/**
 *
 */
const App = (): JSX.Element => {
    const [showHelp, setShowHelp] = useState(false)
    const contentRef = useRef(null)

    // once we have time, this should be part of the main widget
    useWidget()

    const screenSize = useContext(ScreenSizeContext)
    const sidebarHidden = screenSize.mobile || screenSize.tablet

    const classes = styles({ sidebarHidden })

    const {
        verifiedBrandExists,
        brands,
        initialFetching: brandsInitialFetching
    } = useContext(BrandsContext)
    const {
        acceptedCampaignsExists,
        campaigns,
        initialFetching: campaignsInitialFetching
    } = useContext(CampaignContext)
    const {
        campaignsWithNumber,
        initialFetching: numbersInitialFetching
    } = useContext(SmsNumberCampaignContext)

    const onTabChangeEventHandler = (value) => {
        const newUrl = `${basePath}/${value}`
        if (newUrl !== pathname) history.push(newUrl)
    }

    const history = useHistory()
    const { pathname } = useLocation()
    const appPath = '/sms-registration'
    const basePath = `${pathname.split(appPath)[0]}${appPath}`

    const tabs = useMemo(() => {
        const ts = []
        if (verifiedBrandExists) {
            ts.push({
                value: 'brands',
                text: getValue('sms_enrollment_brand_tab_title')
            })
            ts.push({
                value: 'campaigns',
                text: getValue('sms_enrollment_campaign_tab_title')
            })
        }
        if (acceptedCampaignsExists) {
            ts.push({
                value: 'number-assignement',
                text: getValue('transfer_number_number_assignment_title')
            })
        }
        return ts
    }, [verifiedBrandExists, acceptedCampaignsExists])
    const currentTab = useMemo(() => tabs.find((x) => pathname.includes(`/${x.value}`)) || {}, [tabs, pathname])

    useEffect(() => {
        contentRef?.current?.scrollIntoView?.()
    }, [pathname])

    return (
        <div ref={contentRef}>
            <Header
                onClickBack={() => history.goBack()}
                brands={brands}
                campaigns={campaigns}
                campaignsWithNumber={campaignsWithNumber}
            />
            <div className={classes.smsEnrollmentInstructionContainer}>
                {
                    (
                        brandsInitialFetching ||
                        campaignsInitialFetching ||
                        numbersInitialFetching
                    )
                        ? <Loader size={50} />
                        : showHelp
                            ? <SmsEnrollmentInstruction proceedClicked={() => setShowHelp(false)} />
                            : (
                                <div className={classes.container}>
                                    <div className={classes.root}>
                                        {
                                            // only on list pages
                                            tabs.some(
                                                (t) => pathname.endsWith(`/${t.value}`)
                                            ) &&
                                            <Tabs
                                                className={'tabs'}
                                                value={currentTab.value}
                                                onChange={onTabChangeEventHandler}
                                                items={tabs}
                                            />
                                        }
                                    </div>
                                    <div className={classes.content}>
                                        <Switch>
                                            <Route
                                                path={`${basePath}/brands`}
                                                render={() => <Brands />}
                                            />
                                            <Route
                                                path={`${basePath}/campaigns`}
                                                render={() => <Campaigns />}
                                            />
                                            <Route
                                                path={`${basePath}/number-assignement`}
                                                render={() => <NumberAssignement />}
                                            />
                                            <Route
                                                path='/'
                                                render={() => <Redirect to={`${basePath}/brands`} />}
                                            />
                                        </Switch>
                                    </div>
                                </div>
                            )
                }

            </div>
        </div>)
}

export default App
